import { request } from './client';

export interface AdminLoginRequest {
  username: string;
  password: string;
}

export interface AdminTokenResponse {
  username: string;
  role: string;
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  display_name?: string;
}

export function adminLogin(payload: AdminLoginRequest) {
  return request<AdminTokenResponse>({
    url: '/iam/admin/auth/login',
    method: 'POST',
    data: payload,
  });
}

export function adminLogout() {
  return request<void>({
    url: '/iam/admin/auth/logout',
    method: 'POST',
  });
}

export function adminRefresh(refreshToken: string) {
  return request<AdminTokenResponse>({
    url: '/iam/admin/auth/refresh',
    method: 'POST',
    // 放请求体：查询参数会被负载均衡器访问日志整串记录
    data: { refresh_token: refreshToken },
  });
}
